import React from "react";
import { ToggleGroup, ToggleGroupItem } from "components/ui/toggle-group";
import { LayoutGrid, Grid3X3 } from "lucide-react";

export default function ViewToggle({ value, onChange }) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => v && onChange(v)}
      className="border border-[var(--border-color)] bg-[var(--card-bg)] rounded-md p-0.5 flex items-center gap-1"
    >
      <ToggleGroupItem
        value="grid"
        aria-label="Grid view"
        className="px-2.5 data-[state=on]:bg-[var(--toggle-icon)] data-[state=on]:[var(--toggle-text)] hover:bg-[var(--toggle-hover)]"
      >
        <LayoutGrid className="w-5 h-5" />
      </ToggleGroupItem>

      <ToggleGroupItem
        value="list"
        aria-label="List view"
        className="px-2.5 data-[state=on]:bg-[var(--toggle-icon)] data-[state=on]:[var(--toggle-text)]  hover:bg-[var(--toggle-hover)]"
      >
        <Grid3X3 className="w-5 h-5" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
